export default __webpack_public_path__ + "static/media/google.fb4ee34b.jpg";